import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { SubtitleThree } from '../../../../styles/theme/default/typography';
import Icon from '../../../Icon';

const Wrapper = styled.div`
  a {
    font-size: 16px;
  }

  .external-link {
    display: flex;
    align-items: center;
  }

  .icon {
    margin-left: 5px;
    width: 18px;
    height: auto;
  }

  .underline {
    text-decoration: underline;
  }
`;

function NavHoveredMenu({ item, className }) {
  return (
    <Wrapper className={className}>
      <SubtitleThree bold>{item.title}</SubtitleThree>
      <LinkContainer className="link-container">
        {item.links.map((link, i) => {
          if (link.external) {
            return (
              <a
                key={i}
                href={link.url}
                rel="noopener"
                target="_blank"
                className="external-link"
              >
                {link.title}{' '}
                <Icon className="icon" icon="ti-new-tab" size="18px" />
              </a>
            );
          }

          if (link.mailto) {
            return (
              <a
                key={i}
                href={link.url}
                rel="noopener"
                target="_blank"
                className="external-link"
              >
                {link.title}
              </a>
            );
          }

          if (link.underline) {
            return (
              <Link key={i} to={link.url} className="collab-link underline">
                {link.title}
              </Link>
            );
          }

          return (
            <Link key={i} to={link.url} className="collab-link">
              {link.title}
            </Link>
          );
        })}
      </LinkContainer>
    </Wrapper>
  );
}

export default NavHoveredMenu;

const LinkContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;

  a {
    color: ${({ theme }) => theme.colors.charcoal};
    padding-bottom: 15px;
    transition: all 0.15s;
    text-decoration: none;
    &:hover {
      color: ${({ theme }) => theme.colors.french};
    }
  }
`;
